// Estonian

export default {
  component: {

    supportLink: 'support@recright.com',

    layout: {
      endTime: date => (date ? `avatud kuni ${date}` : ''),
    },
    interview: {
      title: 'Vastake videointervjuule',
      submit: 'Saatke vastused ja lõpetage intervjuu',
      continueLater: 'Jätkake hiljem',
      startInterview: 'Alustage intervjuud',
      duplicateError: 'Olete sellel intervjuul juba osalenud. Teile saadeti meil aadressilt invitations@recright.com lingiga, mida saate kasutada intervjuu jätkamiseks.',
      confirmSubmitHeader: 'Te ei ole kõikidele intervjuu küsimustele vastanud',
      confirmSubmitContent: 'Kas soovite siiski intervjuu lõpetada?',
      confirmSubmitContentWarning: 'Teil ei ole hiljem enam võimalik vastamist lõpetada.',
      submitInterviewHeader: 'Esita oma intervjuu vastused',
      submitInterviewContent: 'Kas oled kindel, et soovid oma intervjuu esitada?',
      confirmSubmitButton: 'Saatke vastused ja lõpetage intervjuu',
      preview: 'Video küsimustega saab eelnevalt tutvuda siin',
      requiredQuestionsNotAnswered: 'Palun vastake kõigile kohustuslikele küsimustele enne saatmist.',

      withdrawLink: 'Ei ole sellest ametikohast enam huvitatud? Tühista oma kandidatuur siit.',
    },

    personalInterview: {
      title: 'Select time for an appointment',
      description: [
        'You have been invited to an appointment.',
        'Please select a time slot that suits you best.',
      ],
      position: 'Position:',
      location: 'Location:',
      time: 'Time:',
      timezoneNotice: [
        'Please keep in mind that the times are shown in your timezone.',
        'Your timezone appears to be:',
        'The appointment timezone is:',
      ],
      success: {
        title: 'Thank you',
        description: 'You have successfully scheduled a meeting',
        linkDescription: [
          'You can add the calendar invitation to your own calendar below.',
          'Or you can copy the link to your calendar app:',
        ],
        link: 'Add the calendar invitation to your calendar',
      },
    },

    interviewForm: {
      name: 'Nimi',
      city: 'Kodulinn',
      email: 'e-post',
      phone: 'Telefoninumber',
      link: 'Link',
      legendBasicInfo: 'Põhiline teave',
      placeholderName: 'Sisestage oma nimi',
      placeholderEmail: 'Sisestage oma meiliaadress',
      placeholderPhone: 'Sisestage oma telefoninumber',
      placeholderCity: 'Sisestage oma praegune kodulinn',
      placeholderLink: 'Lisage link, nt oma LinkedIn profiilile.',
      legendAttachments: 'Manused',
      legendAdditionalFields: 'Lisateave',
      required: 'Tärniga märgitud väljad on kohustuslikud.',
    },

    sequencedInterview: {
      networkTest: {
        audio: 'Audio',
        video: 'Video',
        yes: 'Jah',
        no: 'Ei',
        supported: 'Toetatud',
        quality: 'Kvaliteet',
        header: 'Võrguühenduse ja seadme test',
        description: 'Viime nüüd läbi testi veendumaks, et sinu intervjuu jaoks vajalik võrguühendus ja riistvara (kaamera ja mikrofon) töötavad korralikult. Palun luba pärast märguannet testil kasutada nii kaamerat kui mikrofoni ja veendu, et sinu kaamera ei oleks kaetud. Test kestab umbes 30 sekundit. Soovitame sul riistvara testi ajal rääkida.',
        inProgress: 'Toimub test...',
        networkTestResults: 'Võrgutesti tulemused',
        qualityTestResults: 'Kvaliteeditesti tulemused',
        testPassedQuality: 'Kvaliteeditest läbitud',
        testFailedQuality: 'Kvaliteeditest ebaõnnestus',
        testPassedNetwork: 'Võrgutest õnnestus',
        testFailedNetwork: 'Võrgutest ebaõnnestus ',
        startTest: 'Alusta testi',
        startInterview: 'Alusta intervjuud',
        testAgain: 'Korda testi',
        confirmWarning: 'Sind viiakse videointervjuu alguses automaatselt intervjuu esimese küsimuse juurde. Pärast küsimuse vaatamist viiakse sind ette valmistuma.',
        confirmTitle: 'Sinu intervjuu algab kohe',
        confirmText: 'Sul on enne iga küsimust lühidalt aega, et vastuse jaoks valmistuda. Pärast ettevalmistust on sul küsimusele vastamiseks ettemääratud aeg. Sa võid oma vastuse edastada juba enne seda, kui ettemääratud vastamisaeg läbi saab.',
        confirmText2: 'Pärast vastuse saatmist viiakse sind järgmise küsimuse juurde. Protsess kordub, kuni rohkem vastamata küsimusi ei ole.',
        confirmText3: 'Pange tähele, et pärast vastuse salvestamist on teil uue vastuse esitamiseks aega 30 sekundit (kui sellele küsimusele on lubatud vastuse uuesti esitamine). Kui te selle 30-sekundilise ajavahemiku jooksul uue vastuse esitamist ei algata, esitatakse teie praegune vastus automaatselt ja teid suunatakse järgmise küsimuse juurde.',
        goodLuck: 'Hinga sügavalt sisse ja kõik läheb hästi. Kivi kotti!',
        qualityRating: {
          excellent: 'Suurepärane',
          good: 'Hea',
          fair: 'Keskmine',
          poor: 'Kasin',
          bad: 'Puudulik',
        },
      },
      questionAnswerView: {
        title: title => `Vastus intervjuule ${title}`,
        question: 'Küsimus',
        submitAndNext: 'Saada & Järgmine',
        submitSuccess: 'Video saatmine õnnestus!',
        skipText: 'Alusta salvestust',
        stop: 'Seiska',
        submitAndFinish: 'Esita ja lõpeta intervjuu',
        retake: 'Salvesta uuesti',
        take: 'Võte',
        takesLeft: 'võtet alles',
        skipTextQuestion: 'Oled valmis? Liigu edasi',
        retakeConfirmTitle: 'Kas olete kindel, et soovite selle küsimuse vastuse uuesti esitada?',
        retakeConfirmSubmit: 'Jah, alusta esitamist uuesti',
        submitInfoForward: 'Praeguse vastuse automaatne esitamine ja edasiliikumine',
        submitInfoForward2: 'sekunditega',
        nonAnswerableText: 'Sellele sõnumile ei ole vaja vastata. Pärast sõnumi saamist suunatakse teid otse järgmise küsimuse juurde.',
        nonAnswerableVideo: 'Sellele videole ei ole vaja vastata. Pärast videot suunatakse teid otse järgmise küsimuse juurde.',
        answerTimeInfo: (answerMinutes, answerSeconds) =>
          `Sul on küsimuse vastamiseks aega ${answerMinutes} minutit ja ${answerSeconds} sekundit.`,
      },
      publisher: {
        toNextQuestion: timer => `Järgmise küsimuseni on jäänud ${timer}`,
        recordingStarts: timer => `Salvestuse alguseni on jäänud ${timer}`,
      },
      errors: {
        tooManyConnections: 'See ühendus suleti, sest sul on juba teises vahelehes või aknas ühendus avatud.',
        unsupportedBrowser: 'Kahjuks sinu brauser seda toimingut ei toeta. Palun kasuta teist brauserit.',
        networkError: 'Internetiühendus puudub.',
        reconnecting: 'Ühendus katkes. Üritame ühendust taastada.',
        generalError: 'Midagi läks valesti. Palun värskenda lehekülge ja proovi uuesti.',
        allowMediaDevicesError: 'Toimingul ei õnnestunud meediaseadmetega (kaamera ja mikrofon) ühendust luua. Palun veendu, et oled lubanud kaamera ja mikrofoni kasutamise oma brauseris.',
        noAvailableDevicesError: 'Me ei leidnud kaamerat ega mikrofoni.',
        initPublisherError: 'Toiming nurjus tõrke tõttu. Palun veenduge, et olete lubanud brauseril kasutada oma kaamerat ja mikrofoni ning et neid ei kasuta mõni teine rakendus ja proovige uuesti.',
      },
      browserInfo: {
        browserSupportTitle: 'Brauseri tugi',
        supportedBrowsers: 'Test ja intervjuu toetavad järgmiste brauserite uusimaid versioone: Chrome, Firefox, Safari ja Edge.',
        mobileSupported: 'Toetatud mobiiltelefoni brauserid',
        android: 'Android: Google Chrome (uusim versioon), Firefox (uusim versioon)',
        iOS: 'iOS: Safari (uusim versioon)',
        latestVersion: 'Palun veendu, et kasutad brauseri uusimat versiooni. Seda on vaja sujuva toimingu tagamiseks.',
        freezeInstruction: 'Kui videosalvestus ei alga või salvestusekraan jääb mustaks, palun värskendage lehte.',
        unsupportedOnIos: 'Tundub, et kasutad oma iOS seadmes brauserit, millel puudub tugi. Palun kasuta Safari brauserit.',
        ieUnsupported: 'Tundub, et kasutad brauserit Internet Explorer. Kahjuks see test ega intervjuu ei toeta brauserit Internet Explorer. Palun kasuta teist brauserit.',
        qualityTestNotSupported: 'Sinu kasutatav brauser ei toeta kahjuks riistvara testimist. Võid liikuda intervjuu andmise juurde audio ja video kvaliteeti kontrollimata või kasutada selle asemel teist brauserit.',
      },
      reconnectSuccess: 'Ühenduse taastamine õnnestus!',
      continue: 'Jätka',
    },

    withdraw: {
      title: 'Ei ole sellest ametikohast enam huvitatud?',
      description: 'Kandidatuuri tühistamine värbamisprotsessis.',
      buttonText: 'Tühista oma kandidatuur',
      thankYouTitle: 'Aitäh!',
      thankYouText: 'Oled nüüd töölevõtjatele teada andnud, et ei ole sellest ametikohast enam huvitatud.',
      confirm: 'Oled kindel, et soovid oma kandidatuuri tühistada? Pärast tühistamist ei ole enam võimalik sellele ametikohale kandideerida ega sellega seonduval töövestlusel osaleda.',
    },
  },

  page: {
    embeddedProfileInterview: {
      submit: 'Esita',
      continue: 'Jätka',
      supportCenter: 'Recright Help Center',
      thankYou: 'Täname teid videovastuse eest! Võtame teiega varsti ühendust!',
    },

    supportLink: 'support@recright.com',

    finished: {
      title: 'Täname intervjuul osalemise eest!',
      reopenDescription: 'Kui sulgesite selle intervjuu kogemata, pole vaja muretseda! Intervjuu saab uuesti avada, klõpsates allpool olevat nuppu!',
      reopenButtonText: 'Intervjuu uuesti avamine',
      description1: 'Suurepärane - vastasite kõikidele küsimustele ja teie vastused on adressaadile edasi saadetud.',
      descriptionsupport: mailto => `Kui sulgesite intervjuu kogemata, võtke palun ühendust meie klienditeenindusega aadressil ${mailto} ja me avame teie intervjuu uuesti.`,
      descriptionfeedback: 'Teie kogemus on meile tähtis! Kuidas te hindate oma videointervjuule vastamise kogemust? Kuidas saaksime teie meelest oma teenust parandada? Palun jätke oma tagasiside siia.',
      feedbackbutton: 'Andke meile tagasisidet!',
      regularUrl: 'https://www.surveymonkey.com/r/B3ZCSWT',
      timedUrl: 'https://www.surveymonkey.com/r/MZMLPPT',
    },
    messages: {
      title: 'Isiklik sõnum',
    },

    closed: {
      title: 'Intervjuu on lõpetatud või lõppenud.',
      description: 'Videointervjuu, kuhu teid kutsuti, on juba lõppenud või olete kõikidele küsimustele juba vastanud.',
      publicTitle: 'Interview has ended',
      publicDescription: 'The video interview has already ended.',
    },
    saved: {
      title: 'Teie videointervjuu on salvestatud.',
      description: 'Kui soovite videointervjuud jätkata, kasutage teile varem saadetud meilis olevat linki. Kui te intervjuu juurde tagasi pöördute, on varem salvestatud vastused juba olemas. Edu töö leidmisel!',
      remember: 'Kui olete intervjuule vastamise lõpetanud, ärge unustage saata oma vastuseid värbajale.',
      deleteHistory: 'Kui salvestate videointervjuud avalikus arvutis, ärge unustage hiljem oma sirvimise ajalugu kustutada. Sedasi kaitsete oma intervjuu konfidentsiaalsust.',
    },
    unpublished: {
      title: 'Intervjuu pole veel avatud',
      publishTime: publishTime => `Intervjuu avatakse ${publishTime}`,
    },
  },
}
